import { KoobLoader } from '@koob/ui';

// A refresh badge: the B on a navy rounded square, centred at the top of a
// pane whose content stays on screen while it reloads (cards, a map). A first
// load shows the content's skeleton instead (AGENTS.md, Loading states).
const Spinner = () => (
  <div className="absolute left-1/2 top-1 z-raised -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-lg bg-k-h">
    <KoobLoader size={24} onDark />
  </div>
);

export default Spinner;
